import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Socket } from 'ngx-socket-io';
import * as io from 'socket.io-client';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root',
})
export class SocketService {
  private socket;
  private subject = new Subject<any>();

  constructor(private http: HttpClient) {
    this.socket = io.connect(environment.socketURL);
  }

  observer: any;
  getSocketData(path: any): Observable<any> {
    this.socket.on(path, (res: any) => {
      this.observer.next(res);
    });
    return this.getSocketDataObservable();
  }
  getSocketDataObservable(): Observable<any> {
    return new Observable((observer) => {
      this.observer = observer;
    });
  }

  triggerTool() {
    this.subject.next();
  }

  getClickEvent(): Observable<any> {
    return this.subject.asObservable();
  }
}
